module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/logo_header-8ee280b650750d5c28f333627bd9b965.svg";